import React from "react";

const CartIcon = ({ className = "w-6 h-6", strokeColor = "#000000" }) => {
  return (
    <svg
      viewBox="0 -0.5 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.333 19.237C9.33024 19.655 8.98966 19.9918 8.57169 19.99C8.15371 19.9882 7.81611 19.6483 7.81702 19.2303C7.81793 18.8124 8.15702 18.474 8.575 18.474C8.9949 18.4757 9.33411 18.8171 9.333 19.237V19.237Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.881 19.237C13.8782 19.655 13.5376 19.9918 13.1197 19.99C12.7017 19.9882 12.3641 19.6483 12.365 19.2303C12.3659 18.8124 12.705 18.474 13.123 18.474C13.5429 18.4757 13.8821 18.8171 13.881 19.237Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.231 14.263C16.4328 14.367 17.5577 13.6612 17.987 12.534L18.916 10.152L19.427 8.58897C19.4901 8.42231 19.5117 8.24283 19.49 8.06597C19.353 7.26097 18.552 7.34597 17.585 7.34597H7.73804L8.17204 14.263H15.231Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.031 7.59729C7.16923 7.98776 7.59783 8.19224 7.98829 8.054C8.37876 7.91577 8.58324 7.48717 8.445 7.09671L7.031 7.59729ZM7.082 5.494L6.33206 5.48472C6.33096 5.5731 6.3455 5.66098 6.375 5.74429L7.082 5.494ZM6.94332 5.14716L7.48013 4.62339L7.48013 4.62339L6.94332 5.14716ZM6.6 5L6.60916 4.25H6.6V5ZM5.5 4.25C5.08579 4.25 4.75 4.58579 4.75 5C4.75 5.41421 5.08579 5.75 5.5 5.75V4.25ZM8.2236 15.0112C8.63683 14.9827 8.94872 14.6246 8.92022 14.2114C8.89172 13.7982 8.53363 13.4863 8.1204 13.5148L8.2236 15.0112ZM8.172 16.789L8.1204 17.5372C8.13757 17.5384 8.15478 17.539 8.172 17.539V16.789ZM15.289 17.539C15.7032 17.539 16.039 17.2032 16.039 16.789C16.039 16.3748 15.7032 16.039 15.289 16.039V17.539ZM8.445 7.09671L7.789 5.24371L6.375 5.74429L7.031 7.59729L8.445 7.09671ZM7.83194 5.50328C7.836 5.17493 7.70945 4.85842 7.48013 4.62339L6.40651 5.67093C6.35798 5.62119 6.3312 5.55421 6.33206 5.48472L7.83194 5.50328ZM7.48013 4.62339C7.25081 4.38836 6.93751 4.25407 6.60916 4.25006L6.59084 5.74994C6.52135 5.74909 6.45504 5.72067 6.40651 5.67093L7.48013 4.62339ZM6.6 4.25H5.5V5.75H6.6V4.25ZM8.1204 13.5148C7.06334 13.5877 6.2431 14.4664 6.2431 15.526H7.7431C7.7431 15.2548 7.95304 15.0299 8.2236 15.0112L8.1204 13.5148ZM6.2431 15.526C6.2431 16.5856 7.06334 17.4643 8.1204 17.5372L8.2236 16.0408C7.95304 16.0221 7.7431 15.7972 7.7431 15.526H6.2431ZM8.172 17.539H15.289V16.039H8.172V17.539Z"
          fill={strokeColor}
        />
      </g>
    </svg>
  );
};

export default CartIcon;
